export const GET_CLAIM_LIST_REQUEST = 'GET_CLAIM_LIST_REQUEST';
export const GET_CLAIM_LIST_SUCCESS = 'GET_CLAIM_LIST_SUCCESS';
export const GET_CLAIM_LIST_FAILURE = 'GET_CLAIM_LIST_FAILURE';
export const GET_CLAIM_TASK_LIST_REQUEST = 'GET_CLAIM_TASK_LIST_REQUEST';
export const GET_CLAIM_TASK_LIST_SUCCESS = 'GET_CLAIM_TASK_LIST_SUCCESS';
export const GET_CLAIM_TASK_LIST_FAILURE = 'GET_CLAIM_TASK_LIST_FAILURE';
export const GET_CLAIM_HISTORY_REQUEST = 'GET_CLAIM_HISTORY_REQUEST';
export const GET_CLAIM_HISTORY_SUCCESS = 'GET_CLAIM_HISTORY_SUCCESS';
export const GET_CLAIM_HISTORY_FAIURE = 'GET_CLAIM_HISTORY_FAILURE';
export const GET_CLAIM_SUMMARY_REQUEST = 'GET_CLAIM_SUMMARY_REQUEST';
export const GET_CLAIM_SUMMARY_SUCCESS = 'GET_CLAIM_SUMMARY_SUCCESS';
export const GET_CLAIM_SUMMARY_FAIURE = 'GET_CLAIM_SUMMARY_FAILURE';
export const GET_CLAIM_REQUEST = 'GET_CLAIM_REQUEST';
export const GET_CLAIM_SUCCESS = 'GET_CLAIM_SUCCESS';
export const GET_CLAIM_FAILURE = 'GET_CLAIM_FAILURE';
export const GET_CLAIM_DETAILS_REQUEST = 'GET_CLAIM_DETAILS_REQUEST';
export const GET_CLAIM_DETAILS_SUCCESS = 'GET_CLAIM_DETAILS_SUCCESS';
export const GET_CLAIM_DETAILS_FAILURE = 'GET_CLAIM_DETAILS_FAILURE';
export const POST_CLAIM_REQUEST = 'POST_CLAIM_REQUEST';
export const POST_CLAIM_SUCCESS = 'POST_CLAIM_SUCCESS';
export const POST_CLAIM_FAILURE = 'POST_CLAIM_FAILURE';
export const UPDATE_SUBTASK_CLAIM_PROGRESS = 'UPDATE_SUBTASK_CLAIM_PROGRESS';
export const RESET_UPDATED_CLAIM_TASKS = 'RESET_UPDATED_CLAIM_TASKS';
export const RESET_CLAIM_ATTACHMENTS = 'RESET_CLAIM_ATTACHMENTS';
export const ADD_CLAIM_ATTACHMENT_REQUEST = 'ADD_CLAIM_ATTACHMENT_REQUEST';
export const ADD_CLAIM_ATTACHMENT_SUCCESS = 'ADD_CLAIM_ATTACHMENT_SUCCESS';
export const ADD_CLAIM_ATTACHMENT_FAILURE = 'ADD_CLAIM_ATTACHMENT_FAILURE';
export const GET_CLAIM_ATTACHMENT_REQUEST = 'GET_CLAIM_ATTACHMENT_REQUEST';
export const GET_CLAIM_ATTACHMENT_SUCCESS = 'GET_CLAIM_ATTACHMENT_SUCCESS';
export const GET_CLAIM_ATTACHMENT_FAILURE = 'GET_CLAIM_ATTACHMENT_FAILURE';
export const UPDATE_CLAIM_ATTACHMENT_REQUEST =
  'UPDATE_CLAIM_ATTACHMENT_REQUEST';
export const UPDATE_CLAIM_ATTACHMENT_SUCCESS =
  'UPDATE_CLAIM_ATTACHMENT_SUCCESS';
export const UPDATE_CLAIM_ATTACHMENT_FAILURE =
  'UPDATE_CLAIM_ATTACHMENT_FAILURE';
export const DELETE_CLAIM_ATTACHMENT_REQUEST =
  'DELETE_CLAIM_ATTACHMENT_REQUEST';
export const DELETE_CLAIM_ATTACHMENT_SUCCESS =
  'DELETE_CLAIM_ATTACHMENT_SUCCESS';
export const DELETE_CLAIM_ATTACHMENT_FAILURE =
  'DELETE_CLAIM_ATTACHMENT_FAILURE';
export const ADD_CLAIM_NOTE_REQUEST = 'ADD_CLAIM_NOTE_REQUEST';
export const ADD_CLAIM_NOTE_SUCCESS = 'ADD_CLAIM_NOTE_SUCCESS';
export const ADD_CLAIM_NOTE_FAILURE = 'ADD_CLAIM_NOTE_FAILURE';
export const DELETE_CLAIM_NOTE_REQUEST = 'DELETE_CLAIM_NOTE_REQUEST';
export const DELETE_CLAIM_NOTE_SUCCESS = 'DELETE_CLAIM_NOTE_SUCCESS';
export const DELETE_CLAIM_NOTE_FAILURE = 'DELETE_CLAIM_NOTE_FAILURE';
export const UPDATE_CLAIM_NOTE_REQUEST = 'UPDATE_CLAIM_NOTE_REQUEST';
export const UPDATE_CLAIM_NOTE_SUCCESS = 'UPDATE_CLAIM_NOTE_SUCCESS';
export const UPDATE_CLAIM_NOTE_FAILURE = 'UPDATE_CLAIM_NOTE_FAILURE';
export const ADD_CLAIM_REASON_REQUEST = 'ADD_CLAIM_REASON_REQUEST';
export const ADD_CLAIM_REASON_SUCCESS = 'ADD_CLAIM_REASON_SUCCESS';
export const ADD_CLAIM_REASON_FAILURE = 'ADD_CLAIM_REASON_FAILURE';

export const GET_HIDE_TASK_REQUEST = 'claim/GET_HIDE_TASK_REQUEST';
export const GET_HIDE_TASK_SUCCESS = 'claim/GET_HIDE_TASK_SUCCESS';
export const GET_HIDE_TASK_FAILURE = 'claim/GET_HIDE_TASK_FAILURE';

export const POST_HIDE_TASK_REQUEST = 'claim/POST_HIDE_TASK_REQUEST';
export const POST_HIDE_TASK_SUCCESS = 'claim/POST_HIDE_TASK_SUCCESS';
export const POST_HIDE_TASK_FAILURE = 'claim/POST_HIDE_TASK_FAILURE';

export const DELETE_CLAIM_REQUEST = 'claim/DELETE_CLAIM_REQUEST';
export const DELETE_CLAIM_SUCCESS = 'claim/DELETE_CLAIM_SUCCESS';
export const DELETE_CLAIM_FAILURE = 'claim/DELETE_CLAIM_FAILURE';

export const CLEAR_REDUCER = 'claim/clear/reducer/CLEAR_REDUCER';
